var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkHomePage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_618)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1719 0.5C18.7989 0.5 24.1719 5.873 24.1719 12.5C24.1719 19.127 18.7989 24.5 12.1719 24.5C5.54488 24.5 0.171875 19.127 0.171875 12.5C0.171875 5.873 5.54488 0.5 12.1719 0.5ZM12.1719 2C6.37288 2 1.67188 6.701 1.67188 12.5C1.67188 18.299 6.37288 23 12.1719 23C17.9709 23 22.6719 18.299 22.6719 12.5C22.6719 6.701 17.9709 2 12.1719 2Z",
    fill: "#414C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3139 15.642L20.0279 4.64404L9.02992 9.35804L4.31592 20.356L15.3139 15.642ZM17.1719 7.50004L14.1719 14.5L7.17192 17.5L10.1719 10.5L17.1719 7.50004Z",
    fill: "#414C6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1719 13.5C12.7242 13.5 13.1719 13.0523 13.1719 12.5C13.1719 11.9477 12.7242 11.5 12.1719 11.5C11.6196 11.5 11.1719 11.9477 11.1719 12.5C11.1719 13.0523 11.6196 13.5 12.1719 13.5Z",
    fill: "#414C6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_618"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.171875 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkHomePage);
export default __webpack_public_path__ + "static/media/link-Home-Page.be0fc04f516070954cc1e8fda773af3c.svg";
export { ForwardRef as ReactComponent };